/**
 * Generate random number in a range (inclusive)
 *
 * @param min {number}: Min bound
 * @param max {number}: Max bound
 * @returns {number} A random integer in [min, max]
 */
export const getRandomIntFromRange = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1)) + min;
